module.exports = __webpack_public_path__ + "img/special-event_en.c0512ab.jpg";